<template>
  <div>
    <app-history @clicked="$router.push('/tadris-permission-history')" />
    <v-card class="form">
      <div class="fullText">
        شما در اين بخش قادر خواهيد بود، بصورت سيستمي،‌ درخواست خود مبني بر اخذ
        مجوز تدریس یک رشته درسی را ارسال فرمائيد.
        <br />
        درخواست شما توسط واحدهاي مربوطه مركز مديريت بررسي و در صورت تاييد، مجوز
        براي شما صادر خواهد شد.
        <br />
        بعد از صادر شدن مجوز، اطلاع رساني از طريق پيامك صورت خواهد گرفت.
        <br />
        با توجه به ارسال پيامك در امور(نوبت دهي، قبولي و عدم قبولي و ...)به
        شماره تلفن ثبتي در سيستم، از صحيح بودن شماره همراه خود در سيستم اطمينان
        حاصل نمائيد.
        <br />
        ضمنا شما مي توانيد در بخش مشاهده سوابق اقدام به پيگيري درخواست خود
        نمائيد.
        <br />
        لطفا بعد از مطالعه
        <a href="https://hozehkh.com/res/permissionrequest.pdf" target="_blank"
          >دفترچه راهنمای متقاضیان مجوز تدریس</a
        >
        و قبول آن، جهت ارسال درخواست خود ، دكمه درخواست صدور مجوز تدریس را كليك
        فرمائيد.
        <br />
        جهت كسب راهنمايي مي توانيد با شماره تلفن 32008347 تماس حاصل نمائيد.
        <br />
        <br />
        <div style="width: 100%">
          <v-simple-checkbox
            v-model="showButton"
            :ripple="false"
          ></v-simple-checkbox>
          <b
            >موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b
          >
        </div>
      </div>
    </v-card>
    <app-actions v-if="showButton" @nextStep="nextStep"></app-actions>
  </div>
</template>

<script>
import Actions from "./Actions";
import HistoryButton from "@/components/HistoryButton";
export default {
  data() {
    return { showButton: false };
  },
  components: {
    appActions: Actions,
    appHistory: HistoryButton,
  },
  methods: {
    nextStep() {
      this.$emit("nextStep");
    },
  },
};
</script>

<style scoped>
.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}




</style>
